import React from 'react';
import InventoryManager from '../components/InventoryManager';
import { useInventory } from '../hooks/useInventory';

export default function InventoryPage() {
  const { activeBusiness, updateBusiness, isReadOnlyDemo } = useInventory();

  if (!activeBusiness) {
    return (
      <div className="p-8 text-center text-seryi-text">
        <p className="animate-pulse text-xs">Cargando módulo de inventario...</p>
      </div>
    );
  }

  return (
    <InventoryManager
      activeBusiness={activeBusiness}
      onUpdateBusiness={updateBusiness}
      isReadOnlyDemo={isReadOnlyDemo}
    />
  );
}
